//Libs
import { ExistingPurchaseOrder } from "../../models/purchase-order";
import { ExistingPurchaseOrderReceipt } from "../../models/purchase-order-receipt";
import ReceiptFormDialog, { ReceiptFormValues } from "./ReceiptFormDialog";

interface Props {
  isDialogOpen: boolean;
  purchaseOrder: ExistingPurchaseOrder;
  receipts: ExistingPurchaseOrderReceipt[];
  closeDialog: () => void;
  handleSave: (formValues: CreateReceiptFormValues) => Promise<void>;
  loading?: boolean;
  initialValues?: Partial<CreateReceiptFormValues>;
}

export type CreateReceiptFormValues = ReceiptFormValues;

export default function CreateReceiptDialog(props: Props) {
  return (
    <ReceiptFormDialog
      isDialogOpen={props.isDialogOpen}
      purchaseOrder={props.purchaseOrder}
      receipts={props.receipts}
      closeDialog={props.closeDialog}
      handleSave={props.handleSave}
      loading={props.loading}
      initialValues={props.initialValues}
      isEditing={false}
      title={`Create Receipt for PO ${props.purchaseOrder.poNumber}`}
      submitButtonText="Create Receipt"
      busyText="Creating Receipt..."
    />
  );
}
